import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutHeroStack = {
  factory: EElement({
    id: '1ffceb3d-389d-65f6-dba4-b41dd65ab13b',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('215c3ca5-1c8e-362c-b4a0-6c66e9cf45a7')]),
      children: EList([
        EElement({
          id: '1ffceb3d-389d-65f6-dba4-b41dd65ab13c',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '1ffceb3d-389d-65f6-dba4-b41dd65ab13d',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('dd474cd3-ae25-d5ed-de00-845b30762057'),
                  ]),
                  children: EList([
                    EElement({
                      id: '1ffceb3d-389d-65f6-dba4-b41dd65ab140',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Heading')
                      ),
                      data: ERecord({
                        tag: EEnum('h1'),
                        children: EList([
                          EElement({
                            id: '1ffceb3d-389d-65f6-dba4-b41dd65ab141',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Title copy goes here'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '1ffceb3d-389d-65f6-dba4-b41dd65ab142',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Paragraph')
                      ),
                      data: ERecord({
                        styleBlockIds: EList([
                          EText('1b2031fc-27bc-6bb0-9580-913bd9335308'),
                        ]),
                        children: EList([
                          EElement({
                            id: '1ffceb3d-389d-65f6-dba4-b41dd65ab143',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText(
                              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem. Etiam sodales ac felis id interdum.'
                            ),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '1ffceb3d-389d-65f6-dba4-b41dd65ab144',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Link')
                      ),
                      data: ERecord({
                        button: EBoolean(true),
                        eventIds: EList([]),
                        link: ELiteral({
                          name: qualify(
                            Plugins.name('Basic'),
                            typeName('Link')
                          ),
                          value: JSON.parse('{"mode":"external","url":"#"}'),
                        }),
                        block: EText(''),
                        styleBlockIds: EList([
                          EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                        ]),
                        children: EList([
                          EElement({
                            id: '1ffceb3d-389d-65f6-dba4-b41dd65ab145',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Get Started'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'c4042568-1634-a59e-0157-e3589e949c89',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.placeholderImageMountains),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('__wf_reserved_inherit'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"6272f5815b57c07cd6dbfade"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('4ab52b39-9f74-4e6f-6d22-a0f6f2b60477'),
                          EText('1581fcd4-3cdc-d678-00fd-270f748be847'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '215c3ca5-1c8e-362c-b4a0-6c66e9cf45a7',
      type: 'class',
      name: 'Hero Stack',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'dd474cd3-ae25-d5ed-de00-845b30762057',
      type: 'class',
      name: 'Hero Wrapper Two',
      comb: '',
      styleLess:
        'display: flex; max-width: 750px; margin-right: auto; margin-left: auto; flex-direction: column; justify-content: flex-start; align-items: center; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: '1b2031fc-27bc-6bb0-9580-913bd9335308',
      type: 'class',
      name: 'Margin bottom 24px',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: '4ab52b39-9f74-4e6f-6d22-a0f6f2b60477',
      type: 'class',
      name: 'Hero Image',
      comb: '',
      styleLess: 'width: 100%; margin-top: 50px;',
      children: ['1581fcd4-3cdc-d678-00fd-270f748be847'],
      variants: {},
    },
    {
      _id: '1581fcd4-3cdc-d678-00fd-270f748be847',
      type: 'class',
      name: 'Shadow Two',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {},
    },
  ],
} as const;
